import bridge from '@vkontakte/vk-bridge';

/**
 * VK community for the subscribe task.
 * Set via `REACT_APP_VK_GROUP_ID` (numeric community id without a minus sign).
 */
export const VK_COMMUNITY_GROUP_ID: number = (() => {
  const raw = process.env.REACT_APP_VK_GROUP_ID;
  const n = raw != null && raw !== '' ? Number(raw) : NaN;
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
})();

export function isVkCommunityConfigured(groupId = VK_COMMUNITY_GROUP_ID): boolean {
  return Number.isInteger(groupId) && groupId > 0;
}

/** Whether the current user is a member of the community. */
export async function isGroupMember(groupId = VK_COMMUNITY_GROUP_ID): Promise<boolean> {
  if (!isVkCommunityConfigured(groupId)) {
    return false;
  }
  try {
    const info = await bridge.send('VKWebAppGetGroupInfo', { group_id: groupId });
    return info.is_member === 1;
  } catch {
    return false;
  }
}

/**
 * Prompt the user to join the community, then re-check membership.
 */
export async function requestJoinGroup(groupId = VK_COMMUNITY_GROUP_ID): Promise<boolean> {
  if (!isVkCommunityConfigured(groupId)) {
    return false;
  }
  if (await isGroupMember(groupId)) {
    return true;
  }
  try {
    const data = await bridge.send('VKWebAppJoinGroup', { group_id: groupId });
    if (data.result === true) {
      return true;
    }
  } catch {
    // User denied or platform error — still re-check (may already be a member).
  }
  return isGroupMember(groupId);
}
